import { useEffect, useState } from 'react';
import { AuctionDto } from '../../../services/Auction/auctionService.dto';
import { usePopup } from '../../../providers/PopupProvider';
import { auctionService } from '../../../services/Auction/auctionService';
import { useError } from '../../../providers/useError';
import { dateUtils } from '../../../utils/dateUtils';
import { isAuctionWaitingForEnd } from '../utils/auctionUtils';
import { useAuctionEndDetection } from './useAuctionEndDetection';

const END_DATE_DIFF_IN_MS = 3 * 1000;

export const useAuctionClose = (auction?: AuctionDto, refetchAuction?: () => void) => {
  const { showConfirmPopover } = usePopup();
  const { errorMessage } = useError();
  const [canCloseAuction, setCanCloseAuction] = useState(false);

  useAuctionEndDetection(auction, () => setCanCloseAuction(false));

  useEffect(() => {
    setCanCloseAuction(deriveCanCloseAuction(auction));
  }, [auction]);

  const requestAuctionClosure = () => {
    if (!canCloseAuction) return;

    showConfirmPopover('Please confirm if you would like to close this auction?', closeAuction);
  };

  const closeAuction = async () => {
    try {
      if (auction && refetchAuction) {
        const closureDate = new Date(dateUtils.currentDate().getTime() + END_DATE_DIFF_IN_MS);
        await auctionService.editAuction(auction.id, {
          endDateTime: closureDate.toISOString(),
          minimumPrice: auction.minimumPrice,
        });

        refetchAuction();
        setTimeout(refetchAuction, END_DATE_DIFF_IN_MS);
      }
    } catch (error) {
      errorMessage();
    }
  };

  return { canCloseAuction, requestAuctionClosure };
};

const deriveCanCloseAuction = (auction?: AuctionDto) =>
  !!auction && auction.status === 'ONGOING' && !isAuctionWaitingForEnd(auction);
